(() => {
  'use strict';

  // ===== CONFIG =====
  const MESSAGE =
    'You cannot complete checkout with a customization without an associated product. Please remove the customization or add the product again.';

  // Identifies checkout buttons/links across different themes
  const CHECKOUT_SELECTORS = [
    'form[action="/cart"] [name="checkout"]',
    'form[action="/cart"] button[type="submit"][name="checkout"]',
    'button[name="checkout"]',
    'a[href^="/checkout"]',
    'button[data-testid="Checkout-button"]'
  ];

  // ===== MATCHERS (adjust if needed) =====
  function isCustomizationItem(item) {
    const title = (item.product_title || item.title || '').toLowerCase();
    const sku = (item.sku || '').toLowerCase();
    const productType = (item.product_type || '').toLowerCase();

    if (title.startsWith('customization:')) return true;
    if (sku.startsWith('cz-')) return true;
    if (productType === 'customization') return true;

    return false;
  }

  function isRealProductItem(item) {
    return !isCustomizationItem(item);
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Failed to fetch /cart.js');
    return res.json();
  }

  function findCheckoutElements() {
    const els = [];
    for (const sel of CHECKOUT_SELECTORS) {
      document.querySelectorAll(sel).forEach(el => els.push(el));
    }
    return Array.from(new Set(els));
  }

  function ensureNotice() {
    const id = 'standalone-customization-guard-notice';
    let box = document.getElementById(id);
    if (box) return box;

    box = document.createElement('div');
    box.id = id;
    box.style.cssText =
      'margin:12px 0;padding:12px 14px;border:1px solid #e11d48;background:#fff1f2;color:#9f1239;border-radius:10px;font-size:14px;line-height:1.3;';
    box.textContent = MESSAGE;

    const firstCheckout = findCheckoutElements()[0];
    if (firstCheckout && firstCheckout.parentElement) {
      firstCheckout.parentElement.insertBefore(box, firstCheckout);
    } else {
      document.body.prepend(box);
    }
    return box;
  }

  function setCheckoutBlocked(blocked) {
    const checkoutEls = findCheckoutElements();
    const notice = document.getElementById('standalone-customization-guard-notice');

    checkoutEls.forEach(el => {
      if (el.tagName === 'A') {
        if (blocked) {
          el.setAttribute('aria-disabled', 'true');
          el.dataset._scgBlocked = '1';
          el.addEventListener('click', blockLinkClick, true);
          el.style.pointerEvents = 'none';
          el.style.opacity = '0.6';
        } else {
          if (el.dataset._scgBlocked === '1') {
            el.removeEventListener('click', blockLinkClick, true);
            delete el.dataset._scgBlocked;
          }
          el.removeAttribute('aria-disabled');
          el.style.pointerEvents = '';
          el.style.opacity = '';
        }
        return;
      }

      if (blocked) {
        el.disabled = true;
        el.dataset._scgDisabled = '1';
      } else {
        if (el.dataset._scgDisabled === '1') {
          el.disabled = false;
          delete el.dataset._scgDisabled;
        }
      }
    });

    if (blocked) {
      ensureNotice();
    } else if (notice) {
      notice.remove();
    }
  }

  function blockLinkClick(e) {
    e.preventDefault();
    e.stopPropagation();
    alert(MESSAGE);
    return false;
  }

  async function evaluateAndApply() {
    try {
      const cart = await getCart();
      const items = Array.isArray(cart.items) ? cart.items : [];

      const hasCustomization = items.some(isCustomizationItem);
      const hasRealProduct = items.some(isRealProductItem);

      const shouldBlock = hasCustomization && !hasRealProduct;

      setCheckoutBlocked(shouldBlock);
    } catch (err) {
      console.warn('[standalone-customization-guard] error:', err);
      setCheckoutBlocked(false);
    }
  }

  function boot() {
    evaluateAndApply();

    const obs = new MutationObserver(() => {
      window.clearTimeout(window.__scgTimer);
      window.__scgTimer = window.setTimeout(evaluateAndApply, 150);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('focus', evaluateAndApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();